import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { PlanCards } from "@/components/billing/PlanCards";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { t } from "@/i18n";

export default function Pricing() {
  const { user } = useAuth();
  const [cur, setCur] = useState({});
  useEffect(() => { if (user) api.get("/billing").then((r) => setCur(r.data)).catch(() => {}); }, [user]);

  return (
    <div className="min-h-screen bg-background" data-testid="pricing-page">
      <header className="mx-auto flex max-w-6xl items-center justify-between gap-2 px-4 py-6 sm:px-6">
        <Logo />
        <nav className="flex items-center gap-1.5 sm:gap-2">
          <LanguageSwitcher />
          {user
            ? <Button size="sm" asChild data-testid="pricing-dashboard-btn"><Link to="/dashboard">{t("appLayout.tableau_de_bord")}</Link></Button>
            : <Button size="sm" asChild data-testid="pricing-login-btn"><Link to="/login">{t("common.se_connecter")}</Link></Button>}
        </nav>
      </header>
      <main className="mx-auto max-w-6xl px-4 pb-20 pt-6 sm:px-6">
        <h1 className="max-w-2xl text-4xl font-bold tracking-tight sm:text-5xl" data-testid="pricing-title">{t("pricing.title")}</h1>
        <p className="mt-4 max-w-2xl text-base text-muted-foreground md:text-lg">{t("pricing.subtitle")}</p>
        <div className="mt-12"><PlanCards current={cur.plan} currentInterval={cur.interval} trial={cur.trial} /></div>
        <p className="mt-8 text-sm text-muted-foreground" data-testid="pricing-footnote">{t("pricing.footnote_annual")}</p>
      </main>
    </div>
  );
}
